<template>
  <div class="pb-5">
    <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
      Practitioner Registrations
    </h3>
    <Table :columns="columns">
      <practitioners-table-items
        :items="practitioners"
        @getPractitioners="getPractitioners"
        @openSlider="openProfileSlider"
      ></practitioners-table-items>
    </Table>
  </div>
</template>

<script>
import Table from "@/components/shared/Table";
import PractitionersTableItems from "@/components/tables/practitioners/PractitionersTableItems";

export default {
  name: "PractitionerSignupsToday",
  components: { Table, PractitionersTableItems },
  data: () => ({
    columns: ['ID', 'Name', 'Approved', 'Fee From', 'Timezone', 'Verified', 'Payouts', 'Appointments', 'Individual', 'Group', 'Availability', 'More']
  }),
  props: {
    practitioners: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
